/** @format */

export default class Returns {
	constructor() {
		this.instance = self;
	}

	static init() {
		let self = new Returns();
		self.attachEvents();
	}

	attachEvents() {
		let self = this;

		$(document).on("change", ".js-reason-select", function () {
			self.handleReasonChange($(this));
		});

		$(document).on("change", ".js-action-select", function () {
			self.handleActionChange($(this));
		});

		$(document).on("change", ".js-return-quantity-select", function () {
			self.handleQuantityChange($(this));
		});
		$(document).ready(function() {
			$(".basket-item-rows .select2-container").addClass("js-select2OverideContainer ml-0 ml-lg-2 col-lg col-19");
		});
		$(document).on("click", ".js-return-selected-items", function () {
			self.handleReturnSelectedItems($(this));
		});
		$(document).on("click", ".js-confirmation-of-return-items", function () {
			self.handleConfirmReturnSelectedItems($(this));
		});

		$(document).on('change', '.file-input', function(e) {
			const file = e.target.files[0];
			const itemId = $(this).attr('id').replace('photo-upload-', '');
			const container = $(this).siblings('.uploadImageContainer');
			const uploadIcon = $(this).closest('image-for-upload-itemId')

			if (file) {
				const reader = new FileReader();
				reader.onload = function(e) {
					const previewHtml = `
						<div class="col-24 preview-container row">
							<img src="${e.target.result}" id="photo-upload-${itemId}" name="return_data[${itemId}][photo]" class="uploaded-preview mt-2 col-10" style="max-width: 160px; height: auto;">
							<p class="fw-bold mt-1  col-14">${file.name}<a class="remove-upload ml-2 text-decoration-none" id="remove-photo-upload-${itemId}">x</a></p>
						</div>`;

					container.html(previewHtml);
				};
				reader.readAsDataURL(file);
			}
		});

		$(document).on('click', '.remove-upload', function(e) {
			e.preventDefault();
			const container = $(this).closest('.uploadImageContainer');
			const fileInput = container.find('.file-input');
			const itemId = $(this).attr('id').replace('remove-photo-upload-', '');
			const entireContainer = container.parent();
			let reasonContainer = entireContainer.find('select2-return-reason-'+itemId+'-container')

			fileInput.val('');

			container.html(`
						<input type="file" id="photo-upload-${itemId}" name="return_data[${itemId}][photo]" class="file-input col-6" accept="image/*">
						<div class="form-group row mt-3 uploadImageContainer">
									<label for="photo-upload-${itemId}" class="col-4 justify-content-center py-4 upload-label">
										<span class="image-for-upload-${itemId}"><img src="/themes/surridge/app/svgs/upload.svg" height="35" alt="Upload Icon"></span>
									</label>
							<div class="col-20">
								<label class="fw-bold col-24 js-faulty-goods-click td-underline mb-2 mt-2">Upload a photo of faulty goods</label>
								<p class="text-small col-24">Please ensure the defect is shown clearly in the photo</p>
							</div>
						</div>
			`);

			$(this).remove();
		});

		$(document).on('click', '.js-faulty-goods-click', function(e) {
			e.preventDefault();
			const uploadContainer = $(this).closest('.uploadImageContainer');
			const inputToChange = uploadContainer.siblings('.file-input');
			inputToChange.click();
		});
	}

	handleReasonChange($select) {
		let itemId = $select.data("itemId");
		let itemContainer = $("#return-options-" + itemId);
		let thisLoadingSpinner = itemContainer.siblings("#pulsingLoad");
		let actionDropdownContainer = $("#extra-fields-" + itemId);
		let removableActionDropdowns = actionDropdownContainer.siblings(".actionContainer");
		removableActionDropdowns.remove();
		let removableUploadContainer = actionDropdownContainer.siblings(".uploadImageContainer");
		removableUploadContainer.remove();
		let removableUploadDescriptionContainer = actionDropdownContainer.siblings(".imageDescriptionContainer");
		removableUploadDescriptionContainer.remove();
		thisLoadingSpinner.removeClass("d-none");
		let reasonKey = $select.val();
        let container = $("#extra-fields-" + itemId);
		container.siblings('.js-reason-error').remove();
        let config = window.returnReasons ? window.returnReasons.find(r => r.id == reasonKey) : null;
		let stockcodeId = $select.data("stockcodeId");
		console.log(config);
		let actionContainer = $("#extra-fields-" + itemId);
		actionContainer.siblings(".js-size-dropdown").remove();

		let reasonId = reasonKey || $select.data('reasonId') || null;
		let stockcode_id = $select.data('stockcodeId') || null;
		if (!stockcode_id) {
			const $actionEl = $('#return-action-' + itemId);
			if ($actionEl.length) {
				stockcode_id = $actionEl.data('stockcodeId') || $actionEl.data('stockcodeid') || null;
			}
		}
		const orderIdDiv = document.getElementById('order-reference');
		const orderIdText = orderIdDiv ? (orderIdDiv.textContent || orderIdDiv.innerText) : null;
		const orderId = orderIdText ? parseInt(orderIdText, 10) : null;
		oc.ajax('returnItems::onReasonSelect', {
			data: {
				reason_id: reasonId,
				order_id: orderId,
				stockcode_id: stockcode_id
			},
			success: (data) => {
				const $container = $('#return-options-' + itemId);
				if (data && data.error_message) {
					if ($container.length) {
						thisLoadingSpinner.addClass("d-none")
						let $err = $container.find('.js-reason-error');
						if (!$err.length) {
							$err = $('<div class="alert alert-danger d-flex align-items-center js-reason-error" role="alert"><img src="/themes/surridge/app/svgs/cross-white.svg" style="border: 2px solid; border-radius: 50%;" height="20" alt="Upload Icon" class="p-1 mr-2"><div class="text-small errorText"></div></div>');
							$container.append($err)
						}
						let $errMessage = $container.find('.errorText');
						$errMessage.text(data.error_message);
						let dropdownErrorMessage = $container.children(".dropdownNotSelectedError");
						dropdownErrorMessage.remove();
						return;
					} else {
						thisLoadingSpinner.addClass("d-none")
						console.warn('Return reason error:', data.error_message);
					}
					return;
				}
				thisLoadingSpinner.addClass("d-none")
				if ($container.length) {
					$container.find('.js-reason-error').remove();
				}

				if (data && data.list) {
					const $cont = $("#return-options-" + itemId);
					const qty = parseInt($("#return-quantity-" + itemId).val(), 10) || 1;
					this.renderSizeDropdowns(itemId, $cont.find("#extra-fields-" + itemId), qty, data.list);
				}

				if (config.is_image_upload == 1) {
					if (config.name == "Faulty Goods"){
							$container.append(`
								<input type="file" id="photo-upload-${itemId}" name="return_data[${itemId}][photo]" class="file-input col-6" accept="image/*">
								<div class="form-group row mt-3 uploadImageContainer">
											<label for="photo-upload-${itemId}" class="col-4 justify-content-center py-4 upload-label">
												<span class="image-for-upload-${itemId}"><img src="/themes/surridge/app/svgs/upload.svg" height="35" alt="Upload Icon"></span>
											</label>
									<div class="col-20">
										<label class="fw-bold col-24 td-underline js-faulty-goods-click mb-2 mt-2">Upload a photo of faulty goods</label>
										<p class="text-small col-24">Please ensure the defect is shown clearly in the photo</p>
									</div>
								</div>
								<div class="form-group w-100 imageDescriptionContainer">
									<label class="fw-bold">Enter description of the items defect:</label>
									<textarea name="return_data[${itemId}][note]" class="form-control mod-sm" placeholder="Enter Description" rows="2"></textarea>
								</div>
							`);
					} else {
					$container.append(`
						<input type="file" id="photo-upload-${itemId}" name="return_data[${itemId}][photo]" class="file-input col-6" accept="image/*">
						<div class="form-group row mt-3 uploadImageContainer">
									<label for="photo-upload-${itemId}" class="col-4 justify-content-center py-4 upload-label">
										<span class="image-for-upload-${itemId}"><img src="/themes/surridge/app/svgs/upload.svg" height="35" alt="Upload Icon"></span>
									</label>
							<div class="col-20">
								<label class="fw-bold col-24 td-underline js-faulty-goods-click mb-2 mt-2">Upload a photo</label>
								<p class="text-small col-24">Please ensure the incorrect item is clearly in the photo</p>
							</div>
						</div>
						<div class="form-group w-100 imageDescriptionContainer">
							<label class="fw-bold">Enter description:</label>
							<textarea name="return_data[${itemId}][note]" class="form-control mod-sm" placeholder="Enter Description" rows="2"></textarea>
						</div>
					`);
					}
				}


				if (Array.isArray(data.action_list) && data.action_list.length) {
					let actionOptions = data.action_list
						.map(
							(actionObj) =>
								`<option value="${actionObj.action}">${
									actionObj.title
								}</option>`
						)
						.join("");
					$container.append(`
						<div class="align-items-baseline form-group row actionContainer">
							<label class="fw-bold col-5 col-lg-3 px-0" for="return-action-${itemId}">Action:</label>
							<div class="col-19 col-md">
								<select
									name="return_data[${itemId}][action]"
									id="return-action-${itemId}"
									class="form-control mod-sm js-action-select js-select2 actionDropdown"
									data-item-id="${itemId}"
									data-stockcode-id="${stockcodeId}"

								>
									<option value="">Please select</option>
									${actionOptions}
								</select>
							</div>
						</div>
					`);

					if (window.site && typeof window.site.attachSelectPlugin === "function") {
						window.site.attachSelectPlugin($container.find(".js-action-select"));
					} else if ($.fn.select2) {
						$container.find(".js-action-select").select2();
					}
				}
				setTimeout(() => {
					let actionDropdown = $(".actionDropdown");
					let dropdownSibling = actionDropdown.siblings().find(".select2-container");
					dropdownSibling.addClass("col-18 js-select2OverideContainer");
					$(".actionDropdown").siblings().find(".select2-container").addClass("col-18 js-select2OverideContainer");
				}, 5000);
			},
			error: (jqXHR, textStatus, errorThrown) => {
				console.error('AJAX error onReasonSelect', {
					status: jqXHR.status,
					statusText: jqXHR.statusText,
					responseText: jqXHR.responseText,
					textStatus,
					errorThrown
				});
			}
		});

	}

	handleActionChange($select) {
		let itemId = $select.data("itemId");
		let itemContainer = $("#return-options-" + itemId);
		let thisLoadingSpinner = itemContainer.siblings("#pulsingLoad");
		thisLoadingSpinner.removeClass("d-none")
		let action = $select.val(),
		showSizeOn = $select.data("showSize") || [],
		$container = $("#return-options-" + itemId);
		let stockcode_id = $select.data('stockcodeId');
		let orderIdDiv = document.getElementById('order-reference');
		let orderIdText = orderIdDiv.textContent || orderIdDiv.innerText;
		let orderId = parseInt(orderIdText);
		if (showSizeOn.includes(action)) {
			this.renderSizeDropdowns(itemId, $container);
		} else {
			$container.find(".js-size-dropdown").remove();
		}

		let newQuantity = $("#return-quantity-"+itemId)
		let stringSelectedQty = newQuantity.val();
		let selectedQty = Number(stringSelectedQty);

		oc.ajax('returnItems::onReturnActionSelect', {
			data: {
				item_id: itemId,
				stockcode_id: stockcode_id,
				reason: action,
				reasonId: action,
				orderId:orderId
			},
			success: (data, textStatus, jqXHR) => {
				if (data.list && action === "exchange_for_different_size") {
					thisLoadingSpinner.addClass("d-none")
					let quantityEl = $("#return-quantity-" + itemId);
					let selectedQty = parseInt(quantityEl.val(), 10) || 1;
					this.renderSizeDropdowns(itemId, $container, selectedQty, data.list);
				}
			}
		});
		if(action === "exchange_for_different_size"){
		}
		else {
				let actionContainer = $("#extra-fields-" + itemId)
				thisLoadingSpinner.addClass("d-none")
				let siblingSizeDropdowns = actionContainer.siblings(".js-size-dropdown")
				siblingSizeDropdowns.remove()
			}
		}

	handleQuantityChange($select) {
		let itemId = $select.data("itemId");
		let itemContainer = $("#return-options-" + itemId);
		let thisLoadingSpinner = itemContainer.siblings("#pulsingLoad");
		thisLoadingSpinner.removeClass("d-none")
		let itemIdFromSelect = $select.attr("id");
		let parts = itemIdFromSelect.split('-');
		let itemIdString = parts.pop();
		let itemIdQuantity = parseInt(itemIdString, 10);

		let testDiv = document.getElementById("return-action-"+itemIdQuantity);

		if (!testDiv){
		} else {
			let dataTestDiv = testDiv.dataset;
			let stockcodeIdString = dataTestDiv.stockcodeId
			let stockcode_id = Number(stockcodeIdString);
			if( $('#select2-return-reason-'+itemIdString+'-container').attr('title') === 'Ordered wrong size' || $('#select2-return-action-'+itemIdString+'-container').attr('title') === 'Exchange for different size' ){
				let $fields = $select.closest(".js-return-options-fields");
				let reasonWording = $select.closest(".basket-item-rows");
				let reasonWordingSelected = reasonWording.find(".actionDropdown");
				let action = reasonWordingSelected.val();
				oc.ajax('returnItems::onReturnActionSelect', {
						data: {
							item_id: itemIdQuantity,
							stockcode_id: stockcode_id,
							reason: action,
						},
						success: (data, textStatus, jqXHR) => {
							if (data.list) {
								let selectedQty = $select.val();
								let $container = $("#return-options-" + itemIdQuantity)
								let sizeList = data.list;
								this.renderSizeDropdowns(itemIdQuantity, $container, selectedQty, sizeList);
							}
					}});
			} else {
				let itemIdFromSelect = $select.attr("id");
				let parts = itemIdFromSelect.split('-');
				let itemIdString = parts.pop();
				let itemIdQuantity = parseInt(itemIdString, 10);
				let $fields = $select.closest(".js-return-options-fields");
				let selectedQty = $select.val();
				let reason = $fields.find(`[name="return_data[${itemIdQuantity}][reason]"]`).val();
				let container = $("#return-options-" + itemIdQuantity)
				thisLoadingSpinner.addClass("d-none")
			}
		}
	}

	renderSizeDropdowns(itemId, $container, selectedQty, sizeList) {
		let itemContainer = $("#return-options-" + itemId);
		let thisLoadingSpinner = itemContainer.siblings("#pulsingLoad");
		let optionHtml = '';
		let qty = selectedQty !== undefined
			? parseInt(selectedQty, 10) || 1
			: parseInt($("#return-quantity-" + itemId).val(), 10) || 1;
		if (sizeList && typeof sizeList === 'object') {
			optionHtml += '<option value="">Please select</option>';

			for (let stockId in sizeList) {
				if (sizeList.hasOwnProperty(stockId)) {
					let sizeNameArray = sizeList[stockId];
					let outOfStock = sizeNameArray.outOfStock;
					let outOfStockText = outOfStock ? ' - Out of Stock' : '';
					optionHtml += `
						<option
							value="${stockId}"
							data-stockcode-id="${stockId}"
							${outOfStock ? 'disabled' : ''}
							title="${outOfStock ? 'This size is currently Out of Stock' : ''}"
							style="cursor:pointer";
						>
							${sizeNameArray.name} ${outOfStockText}
						</option>`;
				}
			}
		}

		let $template = $(".js-size-dropdown-template");
		thisLoadingSpinner.addClass("d-none")

		if ($template.length === 0) {
			console.error("Size dropdown template element not found.");
			return;
		}

		let templateHtml = $template.html();
		$container.find(".js-size-dropdown").remove();

		for (let i = 0; i < qty; i++) {

			let $htmlString = templateHtml.replace(
				/__SIZE_INPUT__/g,
				`return_data[${itemId}][sizes][${i}]`
			);

			$htmlString = $htmlString.replace(/__SIZE_OPTIONS__/g, optionHtml);

			$container.append($($htmlString));
		}

		let $newSizeSelects = $container.find(".js-return-size-select");
		if (window.site && typeof window.site.attachSelectPlugin === "function") {
			window.site.attachSelectPlugin($newSizeSelects);
		} else if ($.fn.select2) {
			$newSizeSelects.select2();
		}
	}

	handleReturnSelectedItems($button, newData) {
		$(".nothingSelectedError").addClass("d-none")
		let $form = $button.closest('form');
		let isValid = true;
		if ($('.js-toggle-target:checked').length < 1){
			$(".nothingSelectedError").removeClass("d-none")
			return;
		} else {
			$('.js-select2').each(function() {
				let selectValue = $(this).val();
				let parentRow = this.closest('.basket-item-row');
				let dangerAlert = document.querySelectorAll('.basket-item-row .alert-danger');
				let missingDropdownError = document.querySelectorAll('.js-reason-error').length;
				if (selectValue === null || selectValue === '' || missingDropdownError >= 1 || (Array.isArray(selectValue) && selectValue.length === 0)) {
					if (parentRow.style.display === 'none') {
						$(this).removeClass('error-highlight');
						$(this).children('.alert-danger').remove();
					} else {
						isValid = false;
						$(this).addClass('error-highlight');
						let alertElement = parentRow.querySelector('.alert-danger')
							if (alertElement == null){
								$(this).closest(".basket-item-row").append('<div class="alert alert-danger dropdownNotSelectedError d-flex align-items-center" role="alert"><img src="/themes/surridge/app/svgs/cross-white.svg" style="border: 2px solid; border-radius: 50%;" height="20" alt="Upload Icon" class="p-1 mr-2"><div class="text-small">Please ensure all dropdowns have been completed</div></div>')
							}
						}
				} else {
					let $parentDiv = $(this).closest('.basket-item-row');
					let $children = $parentDiv.children();
					let $errorAlert = $parentDiv.find('.dropdownNotSelectedError');
					$(this).removeClass('error-highlight');
					$errorAlert.remove();
				}
			});
			if (!isValid) {
				$('.js-select2.error-highlight').first().focus();
				return
			}
		}

		oc.request($form[0]);
	}

	handleConfirmReturnSelectedItems(){
		let $thisLoadingSpinner = $("#pulsingLoadAllReturns");
		$thisLoadingSpinner.removeClass("d-none");
		const orderReference = this.getCurrentOrderId();

		if (!orderReference) {
			alert('There was an error finding your return order.');
			$thisLoadingSpinner.addClass("d-none");
			return;
		}

		let $confirmReturnButton = $(".js-confirmation-of-return-items")
		$confirmReturnButton.addClass("d-none")

		let $successAlert = $("#returnSuccessfulMessage");
		$successAlert.addClass("d-none");



		oc.ajax('returnItems::onConfirmReturn', {
			data: {
				orderId: orderReference
			},
			method: 'POST',
			success: function(data) {
				location.replace("/account/orders/returns/"+orderReference+"/confirmed-items");
				$successAlert.removeClass("d-none");
			},
			error: function(data, responseCode, xhr) {
				alert('There was an error submitting your return.');
				$thisLoadingSpinner.addClass("d-none");
				$confirmReturnButton.removeClass("d-none")
			}
		});
	}

	getCurrentOrderId() {
		const orderReferenceEl = document.getElementById("order-reference");

		if (orderReferenceEl) {
			return (orderReferenceEl.textContent || orderReferenceEl.innerText || "").trim();
		}

		const pathnameMatch = window.location.pathname.match(/\/account\/orders\/returns\/([^/]+)/);

		return pathnameMatch ? pathnameMatch[1] : null;
	}
}
